(function() {
	/**
	 * Renders service detail: Service Item
	 * @param {Object} props - Page context and properties
	 * @returns {object} Promise
	 */
	WebBaseAprovLV.renderServicePage = function(props) {
		var params = {
			page: props.context.params.page || '',
			detail: props.context.params.detail || ''
		};
		var model = {
			element: null,
			template: 'templates/service.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				navRaw: null,
				pageRaw: null,
				serviceRaw: null,
				nav: null,
				pageContent: null,
				service: null
			}
		};
		return WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=3')
		.then(function(pageRaw) {
			pageRaw = pageRaw || {};
			if (pageRaw.items && Array.isArray(pageRaw.items) && pageRaw.items.length) {
				model.data.pageRaw = pageRaw;
				return WebBaseAprovLV.Utils.getKKData('?system.type=service_item&elements.url[in]=' + params.detail + '&depth=5');
			}
			return $.Deferred().reject(model);
		}).then(function(serviceRaw) {
			var cache;
			var codename = model.data.pageRaw.items[0].elements.navigation.value[0];
			serviceRaw = serviceRaw || {};
			model.data.serviceRaw = serviceRaw;
			if (codename && serviceRaw.items && Array.isArray(serviceRaw.items) && serviceRaw.items.length) {
				cache = WebBaseAprovLV.Cache.get(['navigation', WebBaseAprovLV.lang, codename].join('.')).value;
				if (cache) {
					return cache;
				}
				return WebBaseAprovLV.Utils.getKKData('?system.type=navigation_item&system.codename[in]=' + codename + '&depth=5');
			}
			return $.Deferred().reject(model);
		}).then(function(navRaw) {
			var key;
			var params = [];
			navRaw = navRaw || {};
			model.data.navRaw = navRaw;
			if (navRaw.items && Array.isArray(navRaw.items) && navRaw.items.length) {
				WebBaseAprovLV.Cache.set(['navigation', WebBaseAprovLV.lang, (navRaw.items[0].system || {}).codename || ''].join('.'), navRaw);
			}
			if (model.data.pageRaw && model.data.serviceRaw) {
				model.element = $('#content');
				model.data = $.extend(model.data, {
					pageContent: WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {},
					nav: WebBaseAprovLV.Utils.getKKViewModel(model.data.navRaw)[0] || {},
					service: WebBaseAprovLV.Utils.getKKViewModel(model.data.serviceRaw)[0] || {}
				});
				return WebBaseAprovLV.Utils.transitionTo(model);
			}
			return $.Deferred().reject(model);
		}).promise();
	};
})();
